import React from "react";

import { useEditCoachPoolContext } from "../../../../contexts/EditCoachPoolContext";

export default function Actions() {
  const { dispatch, actions, state } = useEditCoachPoolContext();

  const closeView = (e) => {
    actions.listCoachPools();
  };

  return (
    <>
      <div className="mt20 text-right">
        <a onClick={closeView} className="btn btn-green w-150">
          Close
        </a>
      </div>
    </>
  );
}
